import * as yup from 'yup'
import yupValidation from '../../../lib/yupValidation'
import { validateCPFYup } from '../../../utils/Validators'

export const tarefaSchema = yup.object().shape({
  ordemCarregamento: yup
    .string()
    .nullable()
    .trim()
    .required('Obrigatório'),
  tomador: yup
    .string()
    .nullable()
    .trim()
    .required('Obrigatório'),
  previsaoCarregamento: yup
    .date()
    .required('Obrigatório')
    .typeError('Data Inválida'),
  previsaoEntrega: yup
    .date('')
    .nullable()
    .typeError('Data Inválida'),
  estadoOrigem: yup
    .string()
    .nullable()
    .trim()
    .required('Obrigatório'),
  cidadeOrigem: yup
    .string()
    .nullable()
    .trim()
    .required('Obrigatório'),
  cepOrigem: yup
    .string()
    .nullable()
    .trim()
    .required('Obrigatório'),
  logradouroOrigem: yup
    .string()
    .nullable()
    .trim()
    .required('Obrigatório'),
  numeroOrigem: yup
    .string()
    .nullable()
    .trim()
    .required('Obrigatório'),
  mercadoriaId: yup
    .string()
    .nullable()
    .trim()
    .required('Obrigatório'),
  valorCarga: yup
    .string()
    .nullable()
    .trim()
    .required('Obrigatório'),
  estadoDestino: yup
    .string()
    .nullable()
    .trim()
    .required('Obrigatório'),
  cidadeDestino: yup
    .string()
    .nullable()
    .trim()
    .required('Obrigatório'),
  cepDestino: yup
    .string()
    .nullable()
    .trim()
    .required('Obrigatório'),
  logradouroDestino: yup
    .string()
    .nullable()
    .trim()
    .required('Obrigatório'),
  numeroDestino: yup
    .string()
    .nullable()
    .trim()
    .required('Obrigatório'),
  cpfMotorista: yup
    .string()
    .nullable()
    .test('cpf-validation', 'CPF Inválido', value =>
      validateCPFYup(value || '')
    )
    .required('Obrigatório'),
  nomeMotorista: yup
    .string()
    .nullable()
    .trim()
    .required('Obrigatório'),
  telefoneMotorista: yup
    .string()
    .nullable()
    .trim()
    .required('Obrigatório'),
  placaCavalo: yup
    .string()
    .nullable()
    .trim()
    .required('Obrigatório'),
  nomeResponsavelFrota: yup
    .string()
    .nullable()
    .trim()
    .required('Obrigatório'),
  telefoneResponsavelFrota: yup
    .string()
    .nullable()
    .trim()
    .required('Obrigatório'),
  tecnologia: yup
    .string()
    .nullable()
    .trim()
    .required('Obrigatório')
})

export const tarefaSchemaEmbarcador = tarefaSchema.shape({
  cnh: yup
    .string()
    .nullable()
    .trim(),
  crlv: yup
    .string()
    .nullable()
    .trim()
})

export const validaTarefaSchema = yupValidation(tarefaSchema)
